<template>
    <div class="user-static">
        <div class="user-static-header">
            <span>数据统计</span> 
            <el-button class="btn__style" @click="backList"><i class="el-icon-back"></i> 返回</el-button>
        </div>
        <div class="user-static-chart user-static-item">
            <!-- <UnilateralChart v-if="rsid" :sid="rsid"></UnilateralChart>
            <UserRetreatChart v-if="tableData" :chartX="tableData['drawdown_time']"
            :chartY="tableData['drawdown']"></UserRetreatChart> -->
            <UserStaticChart v-if="tableData && rsid" :chartX="tableData['drawdown_time']"
            :chartY="tableData['drawdown']" :sid="rsid"></UserStaticChart>
        </div>
        
        <div class="user-static-table user-static-item" v-if="tableData">
            <div class="user-static-table_title">
                <span class="user-title_name">指标分析</span>
            </div>
            <table>
                <thead>
                    <tr>
                        <th v-for="(item, index) in tableColumn" :key="'table_'+index">{{item.name}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td v-for="(item, index) in tableColumn" :key="'tbody_'+index">{{indexAnalysis(tableData[item.key], item.key)}}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="user-static-position user-static-item">
            <el-tabs type="border-card">
                <el-tab-pane label="持仓">
                    <table v-if="getPosition">
                        <thead>
                            <tr>
                                <th v-for="(col, index) in positionColumn" :key="'head_'+index">
                                    {{col.name}}
                                </th>
                            </tr>
                        </thead>
                        <tbody v-show="!pShow">
                            <tr :tag="sid" v-for="(item, index) in getPosition.position" :key="'body_'+index">
                                <td v-for="(i, index) in positionColumn" :key="'i_'+index"
                                :style="{'color': buyOrSell(item[i.key])}">{{handlerPosData(item[i.key], i.key)}}</td>
                            </tr>
                        </tbody>
                        <tbody v-show="pShow">
                            <tr :tag="sid" v-for="(item, index) in getPosition.position" :key="'body_'+index">
                                <td v-for="(i, index) in positionColumn" :key="'i_'+index"
                                :style="{'color': buyOrSell(item[i.key])}">{{handlerPosData(item[i.key], i.key)}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <TurnPage @turnPage="turnPageEvent" :tag="2" ref="turnPosition"></TurnPage>
                </el-tab-pane>
                <el-tab-pane label="交易">
                    <table v-if="getPosition" v-loading="tLoading">
                        <thead>
                            <tr>
                                <th v-for="(col, index) in tradeColumn" :key="'head_'+index">
                                    {{col.name}}
                                </th>
                            </tr>
                        </thead>
                        <tbody v-show="!tShow">
                            <tr v-for="(item, index) in getPosition.trade" :key="'body_'+index">
                                <td v-for="(i, index) in tradeColumn" :key="'i_'+index"
                                :style="{'color': buyOrSell(item[i.key])}">{{handleTradeData(item[i.key], i.key)}}</td>
                            </tr>
                        </tbody>
                        <tbody v-show="tShow">
                            <tr v-for="(item, index) in tradeData" :key="'body_'+index">
                                <td v-for="(i, index) in tradeColumn" :key="'i_'+index"
                                :style="{'color': buyOrSell(item[i.key])}">{{handleTradeData(item[i.key], i.key)}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <TurnPage @turnPage="turnPageEvent" :tag="3" ref="turnTrade"></TurnPage>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import UnilateralChart from "@/components/unilateral/Unilateral-chart.vue";
import UserRetreatChart from "@/components/user/User-retreat-chart.vue";
import UserStaticChart from "@/components/user/User-static-chart.vue";
import TurnPage from "@/components/unilateral/Unilateral-turn.vue";
import { mapState } from "vuex";
import { get } from "@/api/index";

export default {
    components: {
        UnilateralChart,
        UserRetreatChart,
        UserStaticChart,
        TurnPage
    },
    data: function () {
        return {
            sid: '',
            tableData: {},
            tableColumn: [
                {name: '总资金', key: 'capital'},
                {name: '可用资金', key: 'cash'},
                {name: '市值', key: 'equity'},
                {name: '初始资金', key: 'initial_money'},
                {name: '胜率', key: 'win_rate'},
                {name: '盈亏比', key: 'win_lose_rate'},
                {name: '累计收益', key: 'accumulated_earnings'},
                {name: '交易天数', key: 'len_days'},
                {name: '最大回撤', key: 'max_drawdown'},
                {name: '收益波动率', key: 'return_volatility'},
                {name: '最近交易时间', key: 'last_trading_time'},
            ],
            positionColumn: [
                { name: '币种', key: 'coin_names'}, // coin_names
                { name: '持仓量', key: 'position'},
                { name: '成本', key: 'cost'},
                { name: '持仓占比', key: 'ratio'},
                { name: '开仓方向', key: 'type'},
            ],
            tradeColumn: [
                { name: '币种', key: 'coin_names'}, // coin_names
                { name: '成交价', key: 'price'},
                { name: '成交量', key: 'trade_num'},
                { name: '交易类型', key: 'type'},
                { name: '交易时间', key: 'create_time'},
            ],
            loadFlag: true,
            rsid: '',
            strategyList: '',
            lengthArr: 0,
            tPage: 1,
            pPage: 1,
            pShow: false,
            tShow: false,
            positionData: [],
            tradeData: [],
            tLoading: false,
        }
    },
    mounted() {
        this.rsid = (this.$route.query.value).split('**')[0];
        console.log('rsid', this.rsid)
        this.createSocket();
        this.getUserRetreat();
    },
    computed: {
        ...mapState([
            'token',
            'userChartData',
            'userStrategyId',
            'userSocket'
        ]),

        getPosition() {
            if (this.strategyList) {
                for (var i=0; i<this.strategyList.strategy.length; i++) {
                    var i_data = this.strategyList.strategy[i];
                    if (i_data.id_ == this.userStrategyId) {
                        this.sid = i_data.id;
                    }
                }

                var position_data = this.strategyList.data[this.sid];

                if (this.pPage == 1) {
                    this.positionData = position_data.position;
                    this.pShow = false;
                } else {
                    this.pShow = true;
                }
                if (this.tPage == 1) {
                    this.tradeData = position_data.trade;
                    this.tShow = false;
                } else {
                    this.tShow = true;
                }
                this.loadFlag = false;
                return position_data;
            } 
        },

        
    },
    methods: {
        // 获取用户指标回测数据
        getUserRetreat() {
            var url = this.$url_LN_local + '/retreat/indicators';
            var param = {
                token: this.token,
                strategyId: this.rsid
            };

            get(url, param).then(res => {
                console.log(typeof res, res);
                if (res.code === 200) {
                    this.tableData = res.data;
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: '提示',
                        offset: 300
                    })
                }
            })
        },

        // 后退
        backList() {
            this.$router.go(-1);
        },

        // 交易数据处理
        handleTradeData(data, key) {
            if (key == 'type') {
                if (data == 1) return "做多";
                else if (data == 2) return "平空";
                else if (data == -1) return "做空";
                else if (data == -2) return "平多";
            }
            return data;
        },

        // websocket 创建
        createSocket() {
            var url = this.$socket_url_ln + "/web/user/socket?token="+this.token;
            // console.log(this.userSocket)
            if (this.userSocket && this.userSocket.skt) {

            } else {
                this.userSocket['skt'] = new WebSocket(url);
                console.log("WebSocket connect successful")
            }

            this.webSocketInit();
        },

        // websocket init
        webSocketInit() {
            this.userSocket.skt.onopen = this.socketOpen;
            this.userSocket.skt.onmessage = this.socketReceive;
            this.userSocket.skt.onclose = this.socketClose;
        },

        // socket 发送函数
        socketOpen() {},

        // socket 接收函数
        socketReceive(res) {
            // console.log(typeof res.data, res.data);
            var res_data = JSON.parse(res.data);
            if (res_data.code === 200) {
                }
            this.strategyList = res_data;
            this.$store.commit('setUserChartData', res_data);
            this.$store.commit('setLoadingFlag', false);
        },

        // socket 关闭函数
        socketClose() {
            console.warn("WebSocket closed!");
        },

        // 多空颜色判断
        buyOrSell(status) {
            if (status == 1 || status == 2) return '#009688';
            else if (status == -1 || status == -2) return '#c17607';
        },

        // 指标分析
        indexAnalysis(data, flag) {
            if (flag == 'win_rate') return data+'%';
            else if (flag == 'accumulated_earnings' || flag == 'max_drawdown') return data+'%';
            return data;
        },

        // 持仓开仓方向
        handlerPosData(data, flag) {
            if (flag == 'type') {
                if (String(data) == '1') return '开多';
                else if (String(data) == '-1') return '开空';
            }
            return data;
        },

        // 翻页
        turnPageEvent(flag, e, tag) {
            console.log('turnPage == ', flag, e, tag);
            var turnId;
            var turnNumber;
            if (tag == '2') {// 持仓
                if (!this.positionData && this.positionData.length == 0) return;
                if (flag == 'next') {
                    turnId = this.positionData.slice(-1)[0].id;
                    turnNumber = 20;
                } else if (flag == 'last') {
                    turnId = this.positionData[0].id;
                    turnNumber = -20;
                }
            } else if (tag == '3') {// 交易
            if (!this.tradeData && this.tradeData.length == 0) return;
                if (flag == 'next') {
                    turnId = this.tradeData.slice(-1)[0].id;
                    turnNumber = 20;
                } else if (flag == 'last') {
                    turnId = this.tradeData[0].id;
                    turnNumber = -20;
                }
            }

            var param = {
                "sign": this.rsid,
                "token": this.token,
                "ids": turnId,
                "types": tag,
                "number": turnNumber
            };

            this.getTurnData(param, flag, e)

        },

        // 获取翻页数据
        getTurnData(param, flag, e) {
            var url = this.$url_LN_local + '/get/page/data';
            
            console.log('param', param);
            get(url, param).then(res => {
                console.log(res);
                if (res.code === 200) {
                    var data = res.data;
                    if (data.length <= 0) {
                        e.turnText = '没有更多数据了!';
                        e.textShow = true;
                        return;
                    } 

                    e.pageChangeEvent(flag);
                    e.textShow = false;

                    if (param.types == '2') {// 持仓
                        this.pPage = e.pages;
                        this.positionData = data;
                    } else if (param.types == '3') {// 交易
                        this.tPage = e.pages;
                        this.tradeData = data;
                    }
                }
            });
        }
    }
}
</script>

<style lang="scss">
.user-static {
    // background-color: #2a2d2e;
    color: #818182;
    width: 1500px;
    margin: 20px auto;

    .user-static-header {
        text-align: left;
        background-color: #1e1e1e;
        padding: 5px;
        button {
            margin-left: 10px;
        }
    }

    .user-static-table_title {
        background-color: #1e1e1e;
        text-align: left;
        // padding: 5px;
        .user-title_name {
            background-color: #2a2d2e;
            display: inline-block;
            padding: 5px 20px;
            width: 60px;
            text-align: center;
        }
    }
    .user-static-item {
        margin: 20px 0;
        table {
            width: 100%;
        }
    }

    .user-static-chart {
        margin-top: 0;
    }

    .user-static-position {
        table {
            thead {
                tr {
                    th{
                        border-bottom: 1px solid #1e1e1e;
                        padding-bottom: 10px;
                    }
                }
            }
            tbody {
                td{
                    padding: 5px 0;
                }
                
                tr:nth-child(even) {
                    background-color: #272829;
                }
                tr:hover {
                    background-color: #1e1e1e;
                }

            }
        }
    }

    .user-static-table {
        margin: 20px 0;
        
        table{
            // border: 1px solid #393a3c;
            width: 100%;
            box-sizing: border-box;
            border-spacing: 0;
            background-color: #2a2d2e;
            thead {
                // background-color: #2a2d2e;
                th {
                    padding: 5px;
                }
            }
            tbody {
                // background-color: #2a2d2e;
                td {
                    padding: 10px;
                }
            }
        }
    }

    .el-tabs--border-card {
        background-color: #2a2d2e; 
        border: 1px solid #1e1e1e;
    }
    .el-tabs--border-card>.el-tabs__header {
        background-color: #1e1e1e;
        border-bottom: 0;
    }
    .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
        background-color: #2a2d2e;
        border-right-color: #2a2d2e;
        border-left-color: #2a2d2e;
    }
    .el-tabs--border-card>.el-tabs__content {
        min-height: 300px;
        padding-bottom: 60px;
    }
}
</style>
